export const RECTIFICATIONS = "shareddefects";
export const DEFECTS = "defects";
export const SUBGRADES = "subgrades";
export const GRADE = "grade";
export const PSC = "psc";
export const MYFLEET = "myfleet";